/**
 * Created by Gustavo on 08/06/2016.
 */

import {Injectable}      from '@angular/core';
import {RequestOptions, Headers, Response, Http} from '@angular/http';
import {AppDataService} from "./app-data.service";
import * as firebase from 'firebase';
declare var Swal : any;
declare var solanaWeb3
declare var splToken ;
@Injectable()
export class WalletService {
    constructor(private _http : Http, private _appData : AppDataService) {
      // Initialize Firebase
      var config = {
        apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
        authDomain: "coolkids-669fa.firebaseapp.com",
        databaseURL: "https://coolkids-669fa.firebaseio.com",
        projectId: "coolkids-669fa",
        storageBucket: "coolkids-669fa.appspot.com",
        messagingSenderId: "159459566585"
      };
      try {
        firebase.initializeApp(config);
        firebase.firestore().settings({ experimentalForceLongPolling: true });

      }
      catch (err){
        console.log('erro no firebase')
        //already connected
      }
    }

    ///////////////////YOUTUBE LIVECHAT//////////////////////////
  public getWallet(kind,id){
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/getWallet?id='+id+'&kind='+kind);
  }
  public sendLamports(user,quantity){

    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/sendLamports?uid='+user.uid+'&quantity='+quantity);
  }

  public getCreateWallet(kind,id){
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/createWallet?id='+id+'&kind='+kind);
  }
  public getBalance(user){
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/getWalletBalance?uid='+user.uid);
  }
  public sendWalletMail(){
    let user=this._appData.instagramUser;
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/sendWalletMail?uid='+user.uid+'&email='+user.email);

  }
  public makeNFT(userId,kind,name,id,Img,props,token){
    let body={
      img:Img,
      props:props,
      id:id,
      url:'https://sojustica-11662.firebaseio.com/'+token+'/'+id+'.json',
      name:name,
      token:token
    }
    if (userId){
      body['walletKind']=kind;
      body['walletId']=userId;
    }
      return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/createNFT',body);


  }
  public tokenForTokenTransaction(idFrom,kindFrom,idTo,kindTo,tokenFrom,tokenTo,quantityFrom,quantityTo,itemFrom,itemTo,dbIdFrom,dbKindFrom,dbIdTo,dbKindTo){
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/tokenForTokenTransaction',{
      idFrom:idFrom,
      kindFrom:kindFrom,
      idTo:idTo,
      kindTo:kindTo,
      tokenFrom:tokenFrom,
      tokenTo: tokenTo,
      quantityFrom:quantityFrom,
      quantityTo:quantityTo,
      itemFrom:itemFrom,
      itemTo:itemTo,dbIdTo:dbIdTo,dbKindTo:dbKindTo,dbIdFrom:dbIdFrom,dbKindFrom:dbKindFrom});
  }
  public makeTokenTransfer(idFrom,kindFrom,idTo,kindTo,token,quantity,item,dbIdFrom,dbKindFrom,dbIdTo,dbKindTo){
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/transferToken',{idFrom:idFrom,kindFrom:kindFrom,idTo:idTo,kindTo:kindTo,token:token,quantity:quantity,item:item,dbIdTo:dbIdTo,dbKindTo:dbKindTo,dbIdFrom:dbIdFrom,dbKindFrom:dbKindFrom});
  }
  public makeNFTTransfer(idFrom,kindFrom,idTo,kindTo,token,quantity){
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/transferToken',{idFrom:idFrom,kindFrom:kindFrom,idTo:idTo,kindTo:kindTo,token:token,quantity:quantity*0.000000001,item:null,dbIdTo:null,dbKindTo:null,dbIdFrom:null,dbKindFrom:null});
  }

  public makePurchaseTransfer(idFrom,kindFrom,idTo,kindTo,token,quantity,item,dbIdFrom,dbKindFrom,dbIdTo,dbKindTo,cost) {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/buyFromLiveplanet',{idFrom:idFrom,kindFrom:kindFrom,idTo:idTo,kindTo:kindTo,token:token,quantity:quantity,item:item,dbIdTo:dbIdTo,dbKindTo:dbKindTo,dbIdFrom:dbIdFrom,dbKindFrom:dbKindFrom,cost:cost});
  }
  public getTokenBalance(kind,id){
      return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/getWalletTokens?id='+id+'&kind='+kind);
  }
  public getProperties(item){
    return this._http.get(item.src);    
  }
  /////////////////////////////////////////////////////////////
  public getNFTs (nft) {
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/getWalletNFTs?uid='+this._appData.instagramUser.uid+'&nft='+nft);
  }
  public getDatabaseNFTs () {
    return this._http.get('https://us-central1-sojustica-11662.cloudfunctions.net/getDatabaseNFTs?uid='+this._appData.instagramUser.uid);
  }
  public getUserNFTs () {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/getNFTByOwner',{
      "idFrom":this._appData.instagramUser.uid,
      "kindFrom":"user"
    });
  }

  public buyLivecoins ( number, holder, cvv , expiration,brand, quantity) {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/buyLivecoins',
    {number:number,
      holder:holder,
      expiration:expiration,
      cvv:cvv,
      brand:brand,
      quantity:quantity,
      id:this._appData.instagramUser.uid,
      kind:'user'
    });
  }
  public buyLivecoinsSpec ( number, holder, cvv , expiration,brand, quantity,id,kind) {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/buyLivecoins',
    {number:number,
      holder:holder,
      expiration:expiration,
      cvv:cvv,
      brand:brand,
      quantity:quantity,
      id:id,
      kind:kind});
  }
  public transactionToLivecoin ( transaction,kind) {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/transactionToLivecoin',
        {transaction:transaction,
        kind:kind}
      );
  }
  public getTransactions ( id,kind) {
    return this._http.post('https://us-central1-sojustica-11662.cloudfunctions.net/getTransactions',
        {id:id,
        kind:kind
      }
      );
  }    
  public updateUserSkill(recipe){     
    let _recipe=recipe
    let reqs
    if (_recipe.requisite){
      reqs=_recipe.requisite[0]
    }
    if (reqs){
      //test if i have the requisite
      if (reqs.tokenId==reqs.id){
        //its a coin...need to check on coins
        this.getTokenBalance('user',this._appData.instagramUser.uid).subscribe(val=>{
          let vet=val.json();
          let lid=0;
          let nfts=[]
          let f=     vet.filter(element => {
            return element.mint_address==reqs.tokenId;
          })

          if (f.length>0){
            if (f[0].ui_amount>=reqs.quantity){
                this.finalizeUpdateSkills(recipe,reqs,null);
            }
            else{
              Swal.fire({title:'Sem requisitos',text:'Essa produção requer que você tenha '+reqs.quantity+ ' de '+reqs.name});
            }
          }
          else{
            Swal.fire({title:'Sem requisitos',text:'Essa produção requer que você tenha '+reqs.quantity+ ' de '+reqs.name});
          }
        });
      }
      else{
        //need to check on my itens
        firebase.firestore().collection('user-container').doc(this._appData.instagramUser.uid).collection('itens').where("recipeId",'==',reqs.id).get().then(v=>{
          let quantity=0;
          let dbItensToLoose=[]
          v.forEach(it=>{
            quantity=quantity+1;
            dbItensToLoose.push(it.data())
          })
          if (quantity>=reqs.quantity){
            this.finalizeUpdateSkills(recipe,reqs,dbItensToLoose);
          }
          else{
            Swal.fire({title:'Sem requisitos',text:'Essa produção requer que você tenha '+reqs.quantity+ ' de '+reqs.name});
          }
        })
      }

    }
    else{
      this.finalizeUpdateSkills(recipe,null,null);
    }
    
  
  }
  public finalizeUpdateSkills(_recipe,reqs,dbItensToLoose){
    let skills=this._appData.userEventSkills;
    let skillVet=skills.filter(v=>{
      return v.name==_recipe.skill.name
    })
    let skill=skillVet[0]
    if (!skill){
      skill={}
      skill.value=0
      skill.tokenId=_recipe.skill.tokenId;
    }
    let myskill=skill.value;
    let minskill=_recipe.minSkill
    let maxskill=_recipe.maxSkill
    let success=false;
    let gain1=0;

    if (myskill <1){
      //need skill to be trained.
      return
    }

    if (myskill<minskill){
            success=false;
            gain1=0;
    }
    else if (myskill>maxskill){
            success=true;
            gain1=0;
    }
    else{
            gain1=(maxskill+50-myskill)
    }
    let check=(Math.random()*100);
    let chance=20
    if (check<gain1){
            chance=50;
            success=true;
    }
    let itemObtained=0;
    if (success){
            itemObtained=Math.ceil(_recipe.baseQuantity*(myskill)/100)
    }
          //skillgain
          check=(Math.random()*100);
          gain1=0;
    if (check<chance){
      if (myskill<10){
              gain1=0.1
      }
      else{
              gain1=0.1
      }
    }
    let hasRecipe=false;

    let text=''
    if (itemObtained){
      let itemLost=null
      let itemLostToken=null;
      let quantityToLoose=0
      if (reqs){
        itemLost=reqs
        itemLostToken=itemLost.tokenId;
        quantityToLoose=itemLost.quantity;
        if (itemLost.id==itemLost.tokenId){
          itemLost=null;
        }
        
      }
      let itemToGain=null
      if (_recipe.kind!='coin'){
        let it=_recipe.toItem();
        itemToGain=it.toDB()
      }
    //NEED TO ADD ITEM TO CONTAINER OR REMOVE ITEM FROM CONTAINER
      if (_recipe.tokenId!=itemLostToken){
        this.tokenForTokenTransaction(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',
                  _recipe.tokenId,itemLostToken,
                  itemObtained,quantityToLoose,
                  itemToGain,itemLost,
                  null,null,this._appData.instagramUser.uid,'user-container').subscribe(res=>{
          if (res.status==200){            
          text='Você obteve ' +itemObtained+' itens de '+_recipe.name+'.'
          if (text.length>0){
          let timerInterval
          Swal.fire({
          title: 'Parabéns!',
          text: text,
          timer: 2000,
          timerProgressBar: false,
          didOpen: () => {
          Swal.showLoading()
          const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
          b.textContent = Swal.getTimerLeft()
          }, 100)
          },
          willClose: () => {
          clearInterval(timerInterval)
          }
          }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
          }
          })
          }      
          }
          })     

      }
      else{
        //just swap itens with no token change
        //first remove reqs
        for (let i=0;i<quantityToLoose;i++){
          let newItem = JSON.parse(JSON.stringify(dbItensToLoose[i]));	
          newItem.owner=this._appData.instagramUser.uid;
          firebase.firestore().collection('user-container').doc(this._appData.instagramUser.uid).collection('itens').doc(newItem.objectId).delete();
        }
        //now add built item
        for (let i=0;i<itemObtained;i++){
          let newItem = JSON.parse(JSON.stringify(itemToGain));
          newItem.objectId=newItem.objectId+i;	
          newItem.owner=this._appData.instagramUser.uid;
          firebase.firestore().collection('user-container').doc(this._appData.instagramUser.uid).collection('itens').doc(newItem.objectId).set(newItem);
        }
        text='Você obteve ' +itemObtained+' itens de '+_recipe.name+'.'
        if (text.length>0){
        let timerInterval
        Swal.fire({
        title: 'Parabéns!',
        text: text,
        timer: 2000,
        timerProgressBar: false,
        didOpen: () => {
        Swal.showLoading()
        const b = Swal.getHtmlContainer().querySelector('b')
        timerInterval = setInterval(() => {
        b.textContent = Swal.getTimerLeft()
        }, 100)
        },
        willClose: () => {
        clearInterval(timerInterval)
        }
        }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
        }
        })
        } 
      }
          
    }
    if (gain1>0 && myskill<100){
          //transfer experience
          this.makeTokenTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'skills',_recipe.skill.tokenId,gain1,null,null,null,null,null).subscribe(res=>{
            if (res.status==200){            
              text=text+'Seu talento de '+_recipe.skill.name+ ' evoluiu em '+gain1+' pontos' 
              if (text.length>0){
                let timerInterval
                Swal.fire({
                  title: 'Parabéns!',
                  text: text,
                  timer: 2000,
                  timerProgressBar: false,
                  didOpen: () => {
                    Swal.showLoading()
                    const b = Swal.getHtmlContainer().querySelector('b')
                    timerInterval = setInterval(() => {
                      b.textContent = Swal.getTimerLeft()
                    }, 100)
                  },
                  willClose: () => {
                    clearInterval(timerInterval)
                  }
                }).then((result) => {
                  if (result.dismiss === Swal.DismissReason.timer) {
                  }
                })
              }  
            }
          })     
    }


  }

}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/wallet.services.ts